import baguetteBox from 'baguettebox.js';
import { BaseController } from './BaseController';

export default class LightboxController extends BaseController {
  id = 'LightboxController';

  init() {
    this.root = this.getRoot();
    this.initSlider();
  }

  initSlider = () => {
    baguetteBox.run('.article-gallery');
  };
}
